import React from 'react';

const Overview = () => {
  return (
    <div className="welcome-background">
    </div>
  );
};

export default Overview;